module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pagination"
  }, [_c('li', {
    class: {
      'pagination--item': true, 'pagination--chevron': true, 'is-disabled': _vm.page == 1
    },
    on: {
      "click": function($event) {
        return _vm.prev()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _vm._l((_vm.pages), function(number, key) {
    return _c('li', {
      key: key,
      class: {
        'pagination--item': true, 'is-active': number == _vm.page, 'is-diabled': number < 0
      }
    }, [(number > 0) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.goToPage(number)
        }
      }
    }, [_vm._v(_vm._s(number))]) : _c('a', [_vm._v("...")])])
  }), _vm._v(" "), _c('li', {
    class: {
      'pagination--item': true, 'pagination--chevron': true, 'is-disabled': _vm.page == _vm.totalPages
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._m(1)])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "icon yule-icon-chevron-left"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('i', {
    staticClass: "icon yule-icon-chevron-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f373be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/Layout/Pagination.vue
// module id = 1860
// module chunks = 0